import React from 'react'

import { Wrapper } from './BadgeWrapper.styles'

const BadgeWrapper = ({ children }) => {
  return <Wrapper className='badges-wrapper'>{children}</Wrapper>
}

export default BadgeWrapper
